import { api } from "@/lib/api";

/** Fire-and-forget: `BusinessMiniSite.jsx` used to own one copy of this and pass it down; the
 * shell split it across `ContactRail` and `MobileActionBar`, so it moved here to stay one
 * function instead of two copies drifting. Never blocks the click it's attached to. */
export function trackInteraction(businessId, interactionType) {
  api.post(`/businesses/${businessId}/interactions`, { interaction_type: interactionType }).catch(() => undefined);
}
